import { createGlobalStyle, css } from "styled-components";
import reset from 'styled-reset'

const GloablStyle = createGlobalStyle`
    ${reset};

    html{
        font-size: 62.5%;
    }

    html,
    body {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    }

    html {
    font-size: 62.5%; //1rem = 10px;
    }

    body {
    font-size: 1.6rem;
    font-family: Noto Sans KR, sans-serif;
    }


    ${({ theme }) => {
        const { fonts } = theme;
        return css`
            body {
                font-family: ${fonts.family.base};
                font-weight: ${fonts.weight.normal};
                font-size: ${fonts.size.base};        
            }
        `;
    }}
`;

export default GloablStyle;